import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { SessionManagement } from '../modal';

export default function reducer(state: SessionManagement = new SessionManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SESSION_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SESSION_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SESSION_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
